// @flow

import type { PaymentOptionEFT, EftBankList } from '@tectonics/prs/incoming-payment/payment-option';

export function getEftBankList(paymentOption: PaymentOptionEFT): EftBankList {
  return paymentOption['bank_list'];
}
